export default function requestLogoutSuccess() {
    return {
        type: requestLogoutSuccess.type,
    };
}

requestLogoutSuccess.type = 'REQUEST_LOGOUT_SUCCESS';
